<template>
    <v-container>
        <v-card class="card">
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="downloadReport">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <div v-show="filter_open" class="pa-5">
                        <v-row>
                            <v-col cols="6">
                                <DynamicSelect label="Tipo da Cota:"
                                               id="TipoCotaSelect"
                                               v-model="filtro.cd_tipo_cota"
                                               placeholder="Selecione os tipo da cota"
                                               endpoint="/dynamic-selects/tipo_cota/id"
                                               :multiple="true"
                                               item-value="cd_tipo_cota"
                                               item-text="label"

                                />
                            </v-col>
                            <v-col cols="6">
                                <Autocomplete label="Produto(s):"
                                              :items="produtos"
                                              v-model="filtro.ids_produtos_selecionados"
                                              item-text="label"
                                              item-value="id_produto"
                                              placeholder="Selecione os produtos"
                                              multiple />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-btn color="secondary" class="mr-4" @click="resetFilter">Limpar</v-btn>
                            <v-btn color="primary mr-n1" @click="filtrar">Filtrar</v-btn>
                        </v-row>
                    </div>
                </collapse-transition>
                <DataTable :headers="headers" :params="params" :filter="custom_filter"
                           url="/painel/datatable/tipo_cota">
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes"
                                           v-bind="attrs"
                                           style="width: 52px;
                                           height: 48px;
                                           padding: 5px;
                                           margin: 10px;
                                           min-width: 48px;"
                                           v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <V-list-item-title>Editar</V-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id_tipo_cota)">
                                        <V-list-item-title>Excluir</V-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{ item.cd_tipo_cota }} - {{ item.tipo_cota }}</td>
                        <td>
                            <div style="display: flex; flex-wrap: wrap;">
                                <span v-for="produto in item.produtos" :key="produto.id_produto" class="mt-2 py-1 px-2" style="background-color: #e0e0e0; margin-right: 5px; margin-bottom: 5px; border-radius: 15px;">
                                    {{ produto.cd_produto }} - {{ produto.nm_produto }}
                                </span>
                            </div>
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { alert, notification } from '../../../plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'ListagemTipoCotas',
    props: {
      atualizaListagem: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        filter_open: false,
        headers: [
          { text: 'Ações', value: '', align: 'center', sortable: false },
          { text: 'Tipo da Cota', value: 'cd_tipo_cota' },
          { text: 'Produtos', value: 'produtos', sortable: false }
        ],
        params: {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'cd_tipo_cota',
            descending: false
          }
        },
        filtro: {
          cd_tipo_cota: [],
          ids_produtos_selecionados: []
        },
        custom_filter: {}
      }
    },
    computed: {
      produtos () {
        const produtos = this.$session.get('produtos').map(produto => ({ id_produto: produto.ID_Produto, cd_produto: produto.CD_Produto, nome: produto.NM_Produto.toUpperCase(), label: `${produto.CD_Produto} - ${produto.NM_Produto.toUpperCase()}` }))
        return produtos.sort(this.ordenar)
      }
    },
    watch: {
      atualizaListagem () {
        this.filtrar()
      }
    },
    methods: {
      getProdutosFormatado (produtos) {
        return produtos.map(produto => produto.cd_produto + ' - ' + produto.nm_produto).join()
      },
      filtrar () {
        this.custom_filter = { ...this.filtro }
      },
      resetFilter () {
        this.filtro = {
          cd_tipo_cota: [],
          ids_produtos_selecionados: []
        }
        this.custom_filter = {}
      },
      editar (item) {
        this.$emit('editar', item)
      },
      async excluir (id_registro) {
        await this.$http.delete(`/painel/tipo_cota/${id_registro}`).then(() => {
          notification(AlertTypes.SUCCESS, 'Tipo de Cota excluído com sucesso!')
        }).catch(() => {
          notification(AlertTypes.ERROR, 'Tivemos um erro ao excluir o tipo de cota, sugerimos tentar novamente e se o problema persistir entre em contato com a Área de Suporte!')
        })
        this.filtrar()
      },
      downloadReport () {
        const filtros = { ...this.filtro }

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: {
            sortBy: this.params.pagination.sortBy,
            descending: this.params.pagination.descending
          },
          headers: this.headers
            .filter(h => h.value && h.value !== '')
            .map(h => h.value),
          headers_formatado: this.headers
            .filter(h => h.value && h.value !== '')
            .map(h => h.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/tipo_cota/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.Msg_Erro || error.message}`)
        }
      },
      confirmExcluir (id_registro) {
        alert({
          text: `Tem certeza que deseja excluir o tipo de cota selecionado?\nOs dados atuais serão mantido nos pedidos, mas não será mais possível selecionar na tela de resumo.`,
          buttons: {
            'Cancelar': () => {},
            'Confirmar': () => this.excluir(id_registro)
          }
        })
      }
    }
  }
</script>
<style>
.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
    padding: 0px;
    min-width: 0;
    width: 48px;
    margin-right: 10px;
}
</style>
